import React, { useState } from "react";
import { useUserContext } from "../components/contexts/UserContext";
import { Button, Col, Input, Row } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import md5 from "md5";
const Login = () => {
  const [state, setState] = useState({
    account: "",
    password: ``,
  });
  const { getLogin } = useUserContext();

  return (
    <div className="h-screen">
      <Row className="h-full">
        <Col span={12} className="w-full flex items-center justify-center">
          <img alt="logo" src="https://e-mongolia.mn/static/assets/d6848f632d79e79cbea47ace93c143f7.svg" />
        </Col>
        <Col span={12}>
          <div className="flex-col flex items-center justify-center h-full px-6 space-y-4 max-w-[400px] mx-auto w-full">
            <img alt="logo" src="https://e-mongolia.mn/static/assets/22f0de95a94e0ff1f5198e7275ff0813.svg" />
            <h1>Welcome to Chat admin</h1>
            <Input value={state.account} onChange={(e: any) => setState({ ...state, account: e.target.value })} className="h-11" size="middle" placeholder="Нэвтрэх нэр" prefix={<UserOutlined />} />

            <Input className="h-11" value={state.password} onChange={(e: any) => setState({ ...state, password: e.target.value })} size="middle" placeholder="Нууц үг" prefix={<LockOutlined />} />

            <Button type="primary" block onClick={() => getLogin({ ...state, password: md5(state.password) })}>
              login
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
